import Modal from "../../../../../global/Modal";
import { useProviderSearchStore } from "../../store/providerSearchStore";
import ProviderSearchContainer from "../ProviderSearchContainer";

export default function ProviderSearchModal({ openModal, setCloseModal }) {
  const { reset } = useProviderSearchStore();

  const onCloseModal = () => {
    reset?.();
    setCloseModal();
  };
  return (
    <Modal open={openModal} closable={false} maxWidth="xl" className="min-w-[75%] h-fit">
      <ProviderSearchContainer isModal={true} onClose={onCloseModal} />
    </Modal>
  );
}
